import * as swcHelpers from '@swc/helpers';
import { hasRequiredListItemFields } from '../types.js';

const getCategorySpecificationListItems = (categories)=>{
    const parentCategories = [];
    for (const category1 of categories){
        if (!category1.ancestors || category1.ancestors.length === 0) continue;
        const parentCategory = category1.ancestors[0];
        const childCategory = category1.ancestors.length > 1 ? category1.ancestors[1] : category1;
        if (!parentCategory || !childCategory) {
            continue;
        }
        if (!hasRequiredListItemFields(parentCategory) || !hasRequiredListItemFields(childCategory)) continue;
        const existingParentCategory = parentCategories.find((category)=>category.key === parentCategory.key
        );
        const existingChildCategory = existingParentCategory === null || existingParentCategory === void 0 ? void 0 : existingParentCategory.children.find((child)=>child.key === childCategory.key
        );
        if (!existingParentCategory) {
            parentCategories.push(swcHelpers.objectSpread({}, parentCategory, {
                children: [
                    childCategory
                ]
            }));
        } else if (!existingChildCategory) {
            existingParentCategory.children.push(childCategory);
        }
    }
    const specificationListItems = parentCategories.map((category)=>({
            key: category.key,
            label: category.name,
            value: category.children.map((child)=>child.name
            ).join(', ')
        })
    );
    // Only return a maximum of 3 additional category specifications
    // to ensure that the specification section does not get bloated
    return specificationListItems.slice(0, 3);
};

export { getCategorySpecificationListItems };
//# sourceMappingURL=get-category-specification-list-items.js.map
